import {DateRange} from './date-range';
import {PresetDateRange} from './presets';
import {DateRangeType, RelativeDate, TimeUnit} from './types';

export class FullLengthDateRange extends DateRange {
  public static get presets(): PresetDateRange[] {
    return [
      PresetDateRange.Today,
      PresetDateRange.Yesterday,
      PresetDateRange.Last7Days,
      PresetDateRange.Last30Days,
      PresetDateRange.Last3Months,
      PresetDateRange.Last6Months,
      PresetDateRange.Last12Months,
    ];
  }

  public getDefaultWindow(): RelativeDate {
    return {
      unit: TimeUnit.Day,
      value: 30,
    };
  }

  public getDateRangeTypeOptions() {
    return [DateRangeType.RelativeAfter, DateRangeType.Between, DateRangeType.Since, DateRangeType.On];
  }

  public getTimeUnitOptions(): TimeUnit[] {
    return [TimeUnit.Minute, TimeUnit.Hour, TimeUnit.Day, TimeUnit.Week, TimeUnit.Month];
  }

  public canUseRolling(): boolean {
    return true;
  }
}
